import { useState } from 'react';
import FiltersBtn from '@/creditflowresearch/ui/common/components/organisms/FiltersBtn';
import SidebarFilters from './SidebarFilters';
import { CFR_ARTICLES } from '@/creditflowresearch/ui/components/creditFlow/articles/FiltersButton/constants';
import { getFiltersByKeysWithValues } from '@framework/ui/Organisms/Filters/helpers';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import {
  useArticlesFilterContext,
} from '@/creditflowresearch/application/ArticlesAndStats/Articles/Filter/ArticlesFilterContext';
import { filtersKeys } from '@/creditflowresearch/ui/components/creditFlow/articles/FiltersButton/Sections/constants';

const FiltersButton = ({ className }: { className?: string }) => {
  const { state: { dateFromMin } } = useArticlesFilterContext();
  const [sidebarIsOpen, setSidebarIsOpen] = useState<boolean>(false);
  const toggleSidebar = (): void => setSidebarIsOpen((prevIsOpen) => !prevIsOpen);
  const { getFilters } = useFiltersContext();
  const filtersState = getFilters(CFR_ARTICLES);
  const filtersCount = Object.keys(getFiltersByKeysWithValues({ filtersState, filtersKeys, dateFromMin })).length;

  return (
    <>
      <FiltersBtn filtersCount={ filtersCount } onClick={ toggleSidebar } className={ className } />
      <SidebarFilters
        // @ts-ignore
        isOpen={ sidebarIsOpen }
        onSidebarToggle={ toggleSidebar }
      />
    </>
  );
};

export default FiltersButton;
